// extracted by mini-css-extract-plugin
export default {"serial_number":"styles_serial_number__gnAIF"};